const EXT_REGEX = /\.([0-9a-z]+)(?:[\?#]|$)/i;

export function getExtension(filename: string) {
  return filename.match(EXT_REGEX)?.[0];
}

export function fixFileName(files: File[], siteIndex: number): File[] {
  const id = `${Date.now()}`;
  return files.map((f, i) => {
    const ext = getExtension(f.name);
    const name = `case-attachment-${id}-${siteIndex + 1}-${i + 1}${ext}`;
    return new File([f], name, { type: f.type });
  });
}
